// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// TYPES
import { CustomPackageState } from "../types";

interface Props {
  pkg: CustomPackageState | null;
  /* Once saved, the unpacked S3 index.html exists — prefer it (faithful render, assets resolve) over
     the best-effort pre-save blob. Rendered inside the iframe, so no S3 URL is ever shown. JH */
  savedSrc?: string;
}

/**
 * JH (30-07-26)
 * Right-column preview for the Custom flow. Renders the staged ad as a bare, borderless iframe sized
 * to its own dimensions — matching DynamicFormatPreview so it sits inside the usual preview container
 * rather than looking like a separate popped-out box. Uses the S3 index.html once saved, else the blob.
 */
export function CustomPackagePreview({ pkg, savedSrc }: Props) {
  const src = savedSrc || pkg?.previewUrl;
  if (!pkg || !src) {
    return (
      <div className="flex flex-column justify-center items-center tc pa5" style={{ minHeight: "320px" }}>
        <ComponentLibrary.PCIconPicker icon={"file-zipper"} size={"2xl"} />
        <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={3} />
        <ComponentLibrary.PCLabel text={"Upload a file to see preview"} />
      </div>
    );
  }

  const width = pkg.inspection.width || 320;
  const height = pkg.inspection.height || 480;

  return <iframe id="custom-preview-iframe" className="bn" title={"custom-preview-iframe"} src={src} width={width} height={height} scrolling={"no"}></iframe>;
}
